export default "__VITE_ASSET__krSm7HMi__"